import type { ActiveLanguage } from '../services/languages';

/** ISO 639-1 base language from a BCP 47 locale tag (e.g. en-GB → en). */
export function getBaseLanguage(locale: string): string {
    const base = locale.split('-')[0]?.trim().toLowerCase();
    return base || locale.toLowerCase();
}

/**
 * Group locales by base language, then sort variants alphabetically by display label.
 * Uses Intl.Collator so non-Latin labels order correctly for the active UI locale.
 */
export function sortLanguagesByLanguage(
    languages: ActiveLanguage[],
    collatorLocale = 'en-US',
): ActiveLanguage[] {
    const collator = new Intl.Collator(collatorLocale, { sensitivity: 'base' });
    return [...languages].sort((a, b) => {
        const byBase = collator.compare(getBaseLanguage(a.locale), getBaseLanguage(b.locale));
        if (byBase !== 0) return byBase;
        return collator.compare(a.label, b.label);
    });
}
